export default __webpack_public_path__ + "static/media/translator.960ccdc9.svg";